var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 3.20997C12.8333 2.85658 12.8333 2.67988 12.7635 2.59806C12.7028 2.52707 12.6119 2.48939 12.5188 2.49672C12.4115 2.50516 12.2866 2.6301 12.0367 2.87999L9.91667 5L12.0367 7.12002C12.2866 7.36991 12.4115 7.49485 12.5188 7.50329C12.6119 7.51062 12.7028 7.47294 12.7635 7.40195C12.8333 7.32013 12.8333 7.14343 12.8333 6.79004V3.20997Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 3.71667C1.16667 2.73658 1.16667 2.24653 1.35741 1.87219C1.52519 1.5429 1.7929 1.27519 2.12219 1.10741C2.49653 0.916672 2.98658 0.916672 3.96667 0.916672H7.11667C8.09676 0.916672 8.58681 0.916672 8.96116 1.10741C9.29044 1.27519 9.55815 1.5429 9.72593 1.87219C9.91667 2.24653 9.91667 2.73658 9.91667 3.71667V6.28334C9.91667 7.26343 9.91667 7.75348 9.72593 8.12782C9.55815 8.45711 9.29044 8.72482 8.96116 8.8926C8.58681 9.08334 8.09676 9.08334 7.11667 9.08334H3.96667C2.98658 9.08334 2.49653 9.08334 2.12219 8.8926C1.7929 8.72482 1.52519 8.45711 1.35741 8.12782C1.16667 7.75348 1.16667 7.26343 1.16667 6.28334V3.71667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.666ab2db2e5321438c4d2fba0e6e7667.svg";
export { ForwardRef as ReactComponent };